export function shouldEnableTeamCalendarSelection({
  calendarView = 'month',
  isMobile = false,
  isAdmin = false
} = {}) {
  // react-big-calendar can finish an iOS touch selection with no slots and
  // then dereference the missing final date. Mobile month navigation is
  // handled by the custom date header instead of drag selection.
  if (isMobile) return false;
  if (calendarView === 'month') return isAdmin;
  return Boolean(isAdmin);
}
